import React from 'react'
import {GameImageContainerComponent} from '../common/parts/game-image-container.component/game-image-container.component';
import {GameDetailsContainerComponent} from './parts/game-details-container/game-details-container.component';
import {OrbitComponentWithState} from '../../base-components/orbit-component-with-state/orbit-component-with-state';
import {GameInfo} from '../../../services/games/game-info';
import {observer} from 'mobx-react';
import {GameBox} from './boxes/game/game.box';
import {PlayRealButtonBox} from './boxes/play-real-button/play-real-button.box';
import {GameImageContainerBox} from './boxes/game-image-container/game-image-container.box';
import {GameNumberBadgeBox} from "./boxes/game-number-badge/game-number-badge.box";
import {Check} from "@sparkware/app-utils";
import { GameIconAnimationState } from '../common/parts/game-image/game-image.component';
import classNames from 'classnames';

export interface SingleGameRegularTemplateComponentProps {
    className: string;
    gameInfo: GameInfo;
    disableGameInfoHover: boolean;
    onMouseEnter: () => void;
    onMouseLeave: () => void;
    onOpenRealGame: () => void;
    onOpenAnonymousGame: () => void;
    onOpenInfoPage: () => void;
    onAnimationIconStateChange?(state: GameIconAnimationState): void;
    gameIndex?: number;
    useSquareIcons?: boolean;
    showNumberBadge?: boolean;
    hasTwoLinesTitle: boolean;
}

interface SingleGameRegularTemplateComponentState {
    active: boolean;
}

@observer
export class SingleGameRegularTemplateComponent extends OrbitComponentWithState<SingleGameRegularTemplateComponentProps, SingleGameRegularTemplateComponentState> {
    public state = {
        active: false
    };
    public stateActiveTimeout: number | null = null;

    /**
     * TODO: If this helps INP web vitals then move the PlayRealButton to a new component including this callback and active state
     */
    private onPlayButtonMouseDown = () => {
        if (this.stateActiveTimeout) {
            clearTimeout(this.stateActiveTimeout);
        }
        this.setState({
            active: true,
        }, () => {
            this.stateActiveTimeout = setTimeout(() => {
                this.setState({
                    active: false
                });
                this.stateActiveTimeout = null;
            }, 1100) as unknown as number
        });
    }

    get gameInfo(): GameInfo {
        return this.props.gameInfo;
    }

    private _renderPlayRealGameButton() {
        return (<PlayRealButtonBox isMobileOS={this.services.device.os.isMobileOS} className={classNames('cy-play-real-game-button', {'play-game-button-active': this.state.active})}
            onMouseDown={this.onPlayButtonMouseDown} onTouchStart={this.onPlayButtonMouseDown}
        />);
    }

    private _renderGameNumberBadge() {
        if(!this.props.showNumberBadge || Check.isNullOrUndefined(this.props.gameIndex)) {
            return null;
        }

        return (
            <GameNumberBadgeBox className={'cy-game-number-badge'}>
                {this.props.gameIndex+1}
            </GameNumberBadgeBox>
        )
    }
    render() {
        return (
            <>

                {this._renderGameNumberBadge()}

                <GameBox className={`cy-single-game-regular-template ${this.props.className}`}
                            onMouseEnter={this.props.onMouseEnter}
                            onMouseLeave={this.props.onMouseLeave}
                            squareGameIcon={this.props.useSquareIcons}
                >

                        <GameImageContainerComponent gameInfo={this.gameInfo}
                                                        box={GameImageContainerBox}
                                                        onOpenRealGame={this.props.onOpenRealGame}
                                                        useSquareIcons={this.props.useSquareIcons}
                                                        playRealGameButton={this._renderPlayRealGameButton()}
                                                        onAnimationIconStateChange={this.props.onAnimationIconStateChange}
                        />

                        <GameDetailsContainerComponent gameInfo={this.gameInfo}
                                                    disableGameInfoHover={this.props.disableGameInfoHover}
                                                    onOpenInfoPage={this.props.onOpenInfoPage}
                                                    onOpenAnonymousGame={this.props.onOpenAnonymousGame}
                                                    squareGameIcon={this.props.useSquareIcons}
                                                    hasTwoLinesTitle={this.props.hasTwoLinesTitle}
                        />
                </GameBox>
            </>
        );
    }
}
